import { render, staticRenderFns } from "./leverage-margin.vue?vue&type=template&id=5019221e&scoped=true"
import script from "./leverage-margin.vue?vue&type=script&lang=js"
export * from "./leverage-margin.vue?vue&type=script&lang=js"
import style0 from "./leverage-margin.vue?vue&type=style&index=0&id=5019221e&prod&scoped=true&lang=css"
import style1 from "./leverage-margin.vue?vue&type=style&index=1&id=5019221e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5019221e",
  null
  
)

export default component.exports